import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import DetailsComponent from "../../components/DetailsComponent";
import { getApi } from '../../api/endpoints.js';
import Circle from '../../models/Circle.js';
import { toast } from 'react-toastify';

const Show = () => {
  const [circleDetails, setCircleDetails] = useState(new Circle().toStateJson());
  const [fetchApi] = getApi('showBranch');
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setCircleDetails((new Circle(response.data.branch, 'show')).toStateJson());
    } catch (error) {
      toast.error(error?.data?.message || 'Something went wrong !')
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.ShowCirclePage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Circle', url: '/circles'}, { label: "Details" }]}
    className={'view-circle-details-page'}
    >
  <PageContentWrapper contentHeading={'Circle Details'}>
    <DetailsComponent data={circleDetails} />
  </PageContentWrapper>
</Page>
};

export default Show;

